const MAPLE_ORDER_NOTES_NAME = 'properties[Notes]';
const MAPLE_CUSTOMER_TYPE_NAME = 'properties[Customer Type]';
const MAPLE_CUSTOMER_NEW = 'New / changed account';
const MAPLE_CUSTOMER_RETURNING = 'Returning customer — use previous details';

function mapleGetOrderNotes(form) {
  if (!form || !form.elements) return null;
  return form.elements.namedItem(MAPLE_ORDER_NOTES_NAME);
}

function mapleGetCustomerTypeField(form) {
  if (!form) return null;
  let field = form.elements?.namedItem(MAPLE_CUSTOMER_TYPE_NAME);
  if (!field) {
    field = document.createElement('input');
    field.type = 'hidden';
    field.name = MAPLE_CUSTOMER_TYPE_NAME;
    form.appendChild(field);
  }
  return field;
}

function mapleGetNotesContainer(notes) {
  if (!notes) return null;
  return (
    notes.closest('.product-form__input') ||
    notes.closest('.field') ||
    notes.parentElement
  );
}

function mapleDirectCheckoutIsValid(form, report = false) {
  const notes = mapleGetOrderNotes(form);
  if (!notes) return true;

  const typeField = mapleGetCustomerTypeField(form);
  const customerType = (typeField?.value || '').trim();
  const notesValue = (notes.value || '').trim();

  if (customerType === MAPLE_CUSTOMER_RETURNING) {
    notes.setCustomValidity('');
    return true;
  }

  if (customerType === MAPLE_CUSTOMER_NEW && notesValue) {
    notes.setCustomValidity('');
    return true;
  }

  if (report) {
    const message = customerType === MAPLE_CUSTOMER_NEW
      ? 'Please enter your Monopoly GO invite link and in-game name.'
      : 'Choose New / changed account or Returning customer before using Buy Now / PayPal.';

    const error = form.querySelector('[data-maple-product-error]');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }

    if (customerType === MAPLE_CUSTOMER_NEW) {
      notes.setCustomValidity(message);
      notes.reportValidity();
      notes.focus();
    } else {
      const firstChoice = form.querySelector('[data-maple-product-choice="new"]');
      firstChoice?.focus();
    }
  }

  return false;
}

function mapleSyncDynamicCheckout(form) {
  if (!form) return;
  const dynamicContainer = form.querySelector('.shopify-payment-button');
  const error = form.querySelector('[data-maple-product-error]');
  const valid = mapleDirectCheckoutIsValid(form, false);

  if (dynamicContainer) {
    dynamicContainer.style.pointerEvents = valid ? '' : 'none';
    dynamicContainer.style.opacity = valid ? '' : '0.48';
    dynamicContainer.setAttribute('aria-disabled', valid ? 'false' : 'true');
  }

  if (valid && error) {
    error.hidden = true;
    error.textContent = '';
  }
}

function mapleSetupProductDetails(form) {
  if (!form || form.dataset.mapleProductDetailsReady === 'true') return;

  const notes = mapleGetOrderNotes(form);
  if (!notes) return;

  form.dataset.mapleProductDetailsReady = 'true';
  notes.required = false;
  notes.removeAttribute('aria-required');
  notes.setCustomValidity('');

  const typeField = mapleGetCustomerTypeField(form);
  const notesContainer = mapleGetNotesContainer(notes);

  const choiceName = `maple_customer_choice_${form.id || Math.random().toString(36).slice(2)}`;
  const wrap = document.createElement('div');
  wrap.className = 'maple-product-details-choice';
  wrap.dataset.mapleProductDetailsChoice = 'true';
  wrap.innerHTML = `
    <div class="maple-product-details-choice__title">Monopoly GO Details</div>
    <div class="maple-product-details-choice__copy">For Buy Now / PayPal only. Adding several items? Add to cart and enter these details once in the cart.</div>
    <label class="maple-product-details-choice__option">
      <input type="radio" name="${choiceName}" value="new" data-maple-product-choice="new">
      <span>New / changed account</span>
    </label>
    <label class="maple-product-details-choice__option">
      <input type="radio" name="${choiceName}" value="returning" data-maple-product-choice="returning">
      <span>Returning customer — use my previous details</span>
    </label>
    <div class="maple-product-details-choice__note">Returning customers: use the same email as your previous order.</div>
    <div class="maple-product-details-choice__error" data-maple-product-error hidden></div>
  `;

  if (notesContainer?.parentNode) {
    notesContainer.parentNode.insertBefore(wrap, notesContainer);
  } else {
    notes.parentNode?.insertBefore(wrap, notes);
  }

  const newRadio = wrap.querySelector('[data-maple-product-choice="new"]');
  const returningRadio = wrap.querySelector('[data-maple-product-choice="returning"]');

  const render = () => {
    const isNew = typeField.value === MAPLE_CUSTOMER_NEW;
    const isReturning = typeField.value === MAPLE_CUSTOMER_RETURNING;

    if (newRadio) newRadio.checked = isNew;
    if (returningRadio) returningRadio.checked = isReturning;

    if (notesContainer) notesContainer.hidden = !isNew;
    notes.disabled = isReturning || !isNew;
    notes.required = false;
    notes.removeAttribute('aria-required');
    notes.setCustomValidity('');

    mapleSyncDynamicCheckout(form);
  };

  newRadio?.addEventListener('change', () => {
    if (!newRadio.checked) return;
    typeField.value = MAPLE_CUSTOMER_NEW;
    notes.disabled = false;
    render();
    setTimeout(() => notes.focus(), 0);
  });

  returningRadio?.addEventListener('change', () => {
    if (!returningRadio.checked) return;
    typeField.value = MAPLE_CUSTOMER_RETURNING;
    notes.value = '';
    render();
  });

  notes.addEventListener('input', () => {
    if ((notes.value || '').trim()) {
      typeField.value = MAPLE_CUSTOMER_NEW;
      if (newRadio) newRadio.checked = true;
    }
    mapleSyncDynamicCheckout(form);
  });

  const observer = new MutationObserver(() => mapleSyncDynamicCheckout(form));
  observer.observe(form, { childList: true, subtree: true });

  render();
}

function mapleSetupAllProductDetails() {
  document.querySelectorAll('product-form form').forEach(mapleSetupProductDetails);
}

document.addEventListener('DOMContentLoaded', mapleSetupAllProductDetails);

// Dynamic Buy Now / PayPal is the only product-page path that requires details.
document.addEventListener(
  'click',
  (event) => {
    const paymentButton = event.target.closest('.shopify-payment-button__button');
    if (!paymentButton) return;

    const form = paymentButton.closest('form') || paymentButton.closest('product-form')?.querySelector('form');
    if (form && !mapleDirectCheckoutIsValid(form, true)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      mapleSyncDynamicCheckout(form);
    }
  },
  true
);

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        mapleSetupProductDetails(this.form);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Add to Cart never stores Monopoly details on each line item.
        // Cart-level attributes collect them once before checkout instead.
        formData.delete(MAPLE_ORDER_NOTES_NAME);
        formData.delete(MAPLE_CUSTOMER_TYPE_NAME);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('table-variant-add-cart')) {
  customElements.define(
    'table-variant-add-cart',
    class TableVariantAddCart extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.tableVariantAddCart.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('button[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      tableVariantAddCart(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

        const items = [];
        const qtys = this.querySelectorAll('.quantity__input');
        qtys.forEach((qty) => {
          if (parseInt(qty.value, 10) > 0) {
            items.push({ id: qty.dataset.variantId, quantity: parseInt(qty.value, 10) });
          }
        });

        if (items.length === 0) {
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          this.submitButton.removeAttribute('aria-disabled');
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({
          items,
          sections: this.cart?.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) return;
            if (this.cart) this.cart.renderContents(response);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
